import { CALL_API } from "../../middleware/api";

export const apiCall = (endpoint, payload, schema, options, actions) => ({
	[CALL_API]: {
		endpoint,
		payload,
		schema,
		options,
		actions
	}
});
